import React from "react";
import { List } from "../modules/ShareRegister";

export function ShareRegisterPage() {
  return <List />;
}
